import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MuxSessionService } from '../../services/mux-session.service';

@Component({
    selector: 'app-folder-picker-dialog',
    templateUrl: './folder-picker-dialog.component.html',
    styleUrls: ['./folder-picker-dialog.component.scss'],
    standalone: false
})
export class FolderPickerDialogComponent implements OnInit {
  currentPath = '~';
  resolvedPath = '';
  items: {name: string; type: string}[] = [];
  loading = false;
  pathSegments: {name: string; path: string}[] = [];
  /** Where the folder lives: '' = the home (this server), else a linked computer's name.
   *  A channel opened on a computer gets affinity for it (its hands run the turns). */
  host = '';
  home = '';
  hosts: { name: string; alive: boolean; location?: string }[] = [];

  constructor(
    public dialogRef: MatDialogRef<FolderPickerDialogComponent>,
    private sessionService: MuxSessionService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      const res = await this.sessionService.listAffinityHosts();
      this.home = res.home || '';
      this.hosts = res.hosts || [];
    } catch {
      this.hosts = [];
    }
    this.navigate('~');
  }

  onHostChange(name: string): void {
    this.host = name || '';
    this.items = [];
    this.navigate('~');
  }

  async navigate(path: string): Promise<void> {
    this.loading = true;
    try {
      const result = await this.sessionService.listDirectory(path, this.host || undefined);
      this.resolvedPath = result.path;
      this.items = result.items;
      this.buildBreadcrumbs(result.path);
    } finally {
      this.loading = false;
    }
  }

  private buildBreadcrumbs(path: string): void {
    const parts = path.split('/').filter(p => p);
    this.pathSegments = [];
    let accumulated = '';
    for (const part of parts) {
      accumulated += '/' + part;
      this.pathSegments.push({ name: part, path: accumulated });
    }
  }

  navigateTo(segment: {name: string; path: string}): void {
    this.navigate(segment.path);
  }

  navigateToRoot(): void {
    this.navigate('/');
  }

  enterFolder(item: {name: string; type: string}): void {
    this.navigate(this.resolvedPath + '/' + item.name);
  }

  goUp(): void {
    const parent = this.resolvedPath.replace(/\/[^/]+\/?$/, '') || '/';
    this.navigate(parent);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onOpen(): void {
    this.dialogRef.close({ path: this.resolvedPath, host: this.host || null });
  }
}
